import Icon from '@material-ui/icons/Build';
import InsList from './InsList'

export default {
    list: InsList,
    //edit: ShipmentEdit,
    //create: DonorCreate,
    icon: Icon,
};
